<div class="itb-toggle-btn">
    <mat-button-toggle-group appearance="legacy" value="default">
        <mat-button-toggle (click)="clickEvent(toggleButtonArray.iconName)" *ngFor='let toggleButtonArray of toggleButtonArray' value="toggleButtonArray.tooltipText" [checked]="toggleButtonArray.isChecked">
            <itb-icon [tooltipText]="toggleButtonArray.tooltipText" [className]="toggleButtonArray.className" >
            </itb-icon>
        </mat-button-toggle>
    </mat-button-toggle-group>
</div>